import { object, string, array, mixed } from "yup";

export const addFilingCompleteDocumentValidation = (showAmount: boolean) =>
  object({
    amount: string().when({
      is: () => showAmount,
      then: string().required("Amount is required"),
      otherwise: string().notRequired(),
    }),
    files: array().of(
      object().when({
        is: (fileObj: { file: File | null; docType: string }) => {
          return !fileObj.file && !fileObj.docType;
        },
        then: object().shape({
          file: mixed().notRequired(),
          docType: string().nullable().notRequired(),
        }),
        otherwise: object().shape({
          file: mixed().required("File is required"),
          docType: string().nullable().required("Document type is required"),
        }),
      })
    ),
  });
